import { DemoIds, IDemo } from 'types'

import { getSharedAsset } from '../utils'

const video = getSharedAsset('blueforce.mp4', 'sessions', 'videos')
const poster = getSharedAsset('blueforce.png', 'sessions', 'posters')
const monolith = getSharedAsset('blueforce.png', 'sessions', 'monoliths')
const nextDemoThumbnail = getSharedAsset('shot-tracker.png', 'demos', 'thumbnails')

export const blueforce: IDemo = {
  id: DemoIds.blueforce,
  video,
  monolith,
  poster,
  end: {
    header: 'How IoT solutions benefit the DOD.',
    body: `Verizon 5G Ultra Wideband can allow Blueforce Development to build systems that enable real-time communication between devices in the US to help improve the adaptability and survivability of U.S. forces.`,
    nextDemoText: '5G Edge and data driven decision making.',
    nextDemoId: DemoIds.shotTracker,
    nextDemoThumbnail,
    previousDemoId: DemoIds.mecExplainer
  }
}
